import { DateTime } from 'luxon';

export enum DateTimeFormat {
  DateTime = 'yyyy-MM-dd HH:mm:ss'
}

export const formatDate = (date: Date, format: string = 'MM/dd/y'): string => {
  try {
    return DateTime.fromJSDate(date).toFormat(format);
  } catch (e) {
    throw new Error('Invalid Date');
  }
};

export const formatDateTime = (date: Date): string => {
  const format = DateTimeFormat.DateTime;

  try {
    return DateTime.fromJSDate(date).toFormat(format).toString();
  } catch (e) {
    throw new Error('Invalid Date');
  }
};

export const parseAnyDate = (
  input: string | Date | number | null,
): Date | null => {
  if (!input) return null;

  let dt: DateTime | null = null;

  try {
    if (input instanceof Date) {
      dt = DateTime.fromJSDate(input);
    }

    else if (typeof input === "number") {
      const millis = input < 1e12 ? input * 1000 : input; // seconds -> ms
      dt = DateTime.fromMillis(millis);
    }

    else if (typeof input === "string") {
      const customFormats = [
        "dd/MM/yyyy HH:mm:ss",
        "dd-MM-yyyy HH:mm:ss",
        "dd/MM/yyyy HH:mm",
        "dd-MM-yyyy HH:mm",
        "dd/MM/yyyy",
        "dd-MM-yyyy",
        "dd/MM",
        "dd-MM",

        "yyyy/MM/dd HH:mm:ss",
        "yyyy-MM-dd HH:mm:ss",
        "yyyy/MM/dd HH:mm",
        "yyyy-MM-dd HH:mm",
        "yyyy/MM/dd",
        "yyyy-MM-dd",
        "MM/dd",
        "MM-dd",
      ];

      for (const fmt of customFormats) {
        const tmp = DateTime.fromFormat(input, fmt);
        if (tmp.isValid) {
          dt = tmp;
          break;
        }
      }

      if (!dt) {
        const parsers = [DateTime.fromISO, DateTime.fromSQL, DateTime.fromRFC2822];
        for (const parseFn of parsers) {
          const tmp = parseFn(input);
          if (tmp.isValid) {
            dt = tmp;
            break;
          }
        }
      }

      if (!dt) {
        const native = new Date(input);
        if (!isNaN(native.getTime())) dt = DateTime.fromJSDate(native);
      }
    }

    if (dt && dt.isValid) {
      return dt.toJSDate();
    }
  } catch (e) {
    console.error("Parse date error:", e);
  }

  return null;
};

export const getCurrentYear = () => DateTime.now().year

export const minDate = DateTime.local(getCurrentYear() - 100, 1, 1).toJSDate();

export const maxDate = DateTime.local(getCurrentYear() + 100, 12, 31).toJSDate();
